import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CloseIcon } from './Icons.jsx';
import { Placeholder } from './ProductCard.jsx';
import { useStore } from '../context/StoreContext.jsx';
import { money } from '../config/brand.js';
import { ik } from '../utils/imagekit.js';

function Shell({ open, title, onClose, children, footer }) {
  return (
    <>
      <div className={`drawer-backdrop${open ? ' is-open' : ''}`} onClick={onClose} />
      <aside className={`drawer${open ? ' is-open' : ''}`} aria-hidden={!open} aria-label={title}>
        <div className="drawer__head">
          <h3>{title}</h3>
          <button type="button" className="iconbtn" onClick={onClose} aria-label={`Close ${title}`}><CloseIcon /></button>
        </div>
        <div className="drawer__body">{children}</div>
        {footer && <div className="drawer__foot">{footer}</div>}
      </aside>
    </>
  );
}

export default function Drawers() {
  const { drawer, setDrawer, cart, cartCount, subtotal, shipping, total, setQuantity, removeLine, wishlist, toggleWishlist, products, settings } = useStore();
  const navigate = useNavigate();
  const close = () => setDrawer(null);
  const saved = products.filter((p) => wishlist.includes(p.id));
  const freeOver = settings.shipping?.freeOver || 0;

  return (
    <>
      <Shell
        open={drawer === 'cart'}
        title={`Shopping Bag (${cartCount})`}
        onClose={close}
        footer={cart.length > 0 && (
          <>
            <div className="sum"><span>Subtotal</span><span>{money(subtotal)}</span></div>
            <div className="sum sum--muted"><span>Shipping</span><span>{shipping ? money(shipping) : 'Free'}</span></div>
            {shipping > 0 && freeOver > 0 && <p className="hint">Add {money(freeOver - subtotal)} more for free shipping.</p>}
            <div className="sum sum--total"><span>Total</span><span>{money(total)}</span></div>
            <button type="button" className="btn btn--block" onClick={() => { close(); navigate('/checkout'); }}>Checkout</button>
          </>
        )}
      >
        {cart.length === 0 ? <p className="empty">Your bag is empty.</p> : cart.map((l) => (
          <div key={l.key} className="line">
            <Link to={`/product/${l.id}`} onClick={close} className="line__img">
              {l.image ? <img src={ik(l.image, 160)} alt={l.name} /> : <Placeholder name={l.name} />}
            </Link>
            <div className="line__info">
              <Link to={`/product/${l.id}`} onClick={close} className="line__name">{l.name}</Link>
              {l.size && <p className="line__meta">Size: {l.size}</p>}
              <p className="line__meta">{money(l.price)}</p>
              <div className="qty qty--small">
                <button type="button" onClick={() => setQuantity(l.key, l.quantity - 1)} aria-label="Decrease quantity">-</button>
                <span>{l.quantity}</span>
                <button type="button" onClick={() => setQuantity(l.key, l.quantity + 1)} aria-label="Increase quantity">+</button>
              </div>
            </div>
            <button type="button" className="linkbtn" onClick={() => removeLine(l.key)}>Remove</button>
          </div>
        ))}
      </Shell>

      <Shell open={drawer === 'wishlist'} title={`Wishlist (${saved.length})`} onClose={close}>
        {saved.length === 0 ? <p className="empty">Nothing saved yet.</p> : saved.map((p) => (
          <div key={p.id} className="line">
            <Link to={`/product/${p.id}`} onClick={close} className="line__img">
              {p.image ? <img src={ik(p.image, 160)} alt={p.name} /> : <Placeholder name={p.name} />}
            </Link>
            <div className="line__info">
              <Link to={`/product/${p.id}`} onClick={close} className="line__name">{p.name}</Link>
              <p className="line__meta">{money(p.price)}</p>
            </div>
            <button type="button" className="linkbtn" onClick={() => toggleWishlist(p.id)}>Remove</button>
          </div>
        ))}
      </Shell>
    </>
  );
}
